import React, { useContext, useEffect, useRef, useState } from 'react'
import { filter, get, isEmpty } from 'lodash'
import * as PropTypes from 'prop-types'
import {DebounceInput} from 'react-debounce-input'
import {
  MenuContextToggle,
  MenuFiltered,
  MenuAppendicesFiltered,
  MenuMaterialsFiltered,
  BookInfo, UserInfo,
} from '../../contexts/menuContext'
import ChapterMenu from './chapter'

const recursiveSearch = (search, chapterMenuRecurs) => {
  if (search !== '') {
    let result = chapterMenuRecurs.map((item) => {
      if (!isEmpty(get(item, 'children', []))) {
        item.nextChildren =  get(item, 'children',[])
        item.children = recursiveSearch(search,get(item, 'children'))
      }
      return item
    })

    result = filter(result, (item) => {
      if (item.value.title.toLowerCase().search(search.toLowerCase()) >= 0 && item.nextChildren && item.nextChildren.length > 0) {
        item.children = [item.nextChildren[0]]
      }
      return (
        (item.value.title.toLowerCase().search(search.toLowerCase()) >= 0 &&
          isEmpty(get(item, 'children'))) ||
        !isEmpty(get(item, 'children'))
      )
    })
    return result
  }
  return chapterMenuRecurs
}

const fdcCaseConnectorIntro = (bookcode) => {
  return (
    (bookcode == 'FDC') && <div className="pdcpa-case-connector">
        <a className="title" href="/case-connector" title="FDCPA Case Connector" target="_blank">FDCPA Case Connector</a>
        <a href="/case-connector" target="_blank" alt="FDCPA Case Connector"><img src="/themes/custom/nclc/images/case-connector.png" /></a>
        <br/>
        <a className="intro" href="/case-connector" target="_blank">The <span>FDCPA Case Connector</span> is a database of all 15,000 Appx E summaries of FDCPA case holdings. Sort by any combination of court, topic, year, citation, party name, and keyword.</a>
    </div>
  )
}
const ChapterMenuNavigation = ({ navigation, navigationOnly }) => {
  const [searchString, setSearchString] = useState('')
  const [chapterMenu, changeChapterMenu] = useContext(MenuFiltered)
  const [book] = useContext(BookInfo)
  const [user] = useContext(UserInfo)
  const ref = useRef(null)
  const filterMenu = (searchValue) => {
    setSearchString(searchValue)
    changeChapterMenu(recursiveSearch(searchValue, JSON.parse(JSON.stringify(navigation))))
  }
  const contact = get(book, 'relationships.contact_editor')
  useEffect(() => {
    window.Drupal.attachBehaviors()
  }, [])
  useEffect(() => {
    if (ref.current && !get(user, 'id')) {
      ref.current.classList.add('anonymous')
    }
  }, [ref, user])
  const [toggleMenu, setToggleMenu] = useState(false)
  const bookcode = get(book, 'bookcode')
  return (
    <MenuContextToggle.Provider value={[toggleMenu, setToggleMenu]}>
      <div className="chapter-menu">
        {!navigationOnly &&
          <><div className="switch-wrapper">
            <div className="switch-wrapper-contact">
              {contact && <span ref={ref} dangerouslySetInnerHTML={{ __html: contact }} />}
            </div>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="customSwitches"
                onChange={() => {
                  setToggleMenu(!toggleMenu)
                }}
                checked={toggleMenu}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="custom-control-label" htmlFor="customSwitches" ><span>Expand All</span></label>
            </div>
          </div>
             { fdcCaseConnectorIntro(bookcode) }
            <div className="search">
              <label>Search table of contents</label>
              <DebounceInput
                minLength={3}
                debounceTimeout={500}
                onChange={(e) => {
                  filterMenu(e.target.value)
                  setToggleMenu(e.target.value ? true : false)
                }}
                name="Search"
                type="text"
                autoComplete="off"
                value={searchString}
              />
            </div>
          </>}
        {chapterMenu.length ? (
          <ChapterMenu menuItems={chapterMenu} toggleMenu={toggleMenu} level={0} type="chapters" navigationOnly/>
        ) : (
          <div>No results found</div>
        )}
      </div>
    </MenuContextToggle.Provider>
  )
}

export const AppendicesMenuNavigation = ({ type = false, appendicesMenu, materialsMenu, navigationOnly }) => {
  const [book] = useContext(BookInfo)
  const [searchString, setSearchString] = useState('')
  const [appendices, changeAppendices] = useContext(MenuAppendicesFiltered)
  const [materials, changeMaterials] = useContext(MenuMaterialsFiltered)
  const chapterMenu = type === 'materials' ? materials : appendices
  const changeChapterMenu = type === 'materials' ? changeMaterials : changeAppendices
  const [toggleMenu, setToggleMenu] = useState(false)
  const [user] = useContext(UserInfo)
  const ref = useRef(null)
  const bookcode = get(book, 'bookcode')
  const navigation = type === 'materials' ? materialsMenu : appendicesMenu

  const filterMenu = (searchValue) => {
    setSearchString(searchValue)
    changeChapterMenu(recursiveSearch(searchValue, JSON.parse(JSON.stringify(navigation))))
  }
  useEffect(() => {
    window.Drupal.attachBehaviors()
  }, [])
  useEffect(() => {
    if (ref.current && !get(user, 'id')) {
      ref.current.classList.add('anonymous')
    }
  }, [ref, user])
  return (
    <MenuContextToggle.Provider value={[toggleMenu, setToggleMenu]}>
      <div className="chapter-menu">
        {!navigationOnly &&
          <><div className="switch-wrapper">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={type === 'materials' ? 'customMaterialSwitches' : 'customAppendicesSwitches'}
                  onChange={() => {
                    setToggleMenu(!toggleMenu);
                  }}
                  checked={toggleMenu}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label
                  className="custom-control-label"
                  htmlFor={type === 'materials' ? 'customMaterialSwitches' : 'customAppendicesSwitches'}
                >
                  <span>Expand All</span>
                </label>
              </div>
            </div>
            {fdcCaseConnectorIntro(bookcode)}
            <div className="search">
              <label>Search of appendices</label>
              <DebounceInput
                minLength={3}
                debounceTimeout={500}
                onChange={(e) => {
                  filterMenu(e.target.value);
                  setToggleMenu(e.target.value ? true : false);
                }}
                name="Search"
                type="text"
                autoComplete="off"
                value={searchString}
              />
            </div>
          </>}

        {chapterMenu.length ? (
          <ChapterMenu menuItems={chapterMenu} toggleMenu={toggleMenu} type={type} navigationOnly/>
        ) : (
          <div>No results found</div>
        )}
      </div>
    </MenuContextToggle.Provider>
  )
}

AppendicesMenuNavigation.defaultProps = {
  type: false,
}

ChapterMenuNavigation.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
  ).isRequired,
}
AppendicesMenuNavigation.propTypes = {
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  appendicesMenu: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
  ).isRequired,
  materialsMenu: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
  ).isRequired,
}

export default ChapterMenuNavigation
